import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { ButtonShowcase } from './primitives/ButtonShowcase';
import { CheckboxShowcase } from './primitives/CheckboxShowcase';
import { InputShowcase } from './primitives/InputShowcase';
import { SelectShowcase } from './primitives/SelectShowcase';

export function PrimitivesSection() {
  const { t } = useTranslation();

  return (
    <section id="primitives" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.primitives.title')}
        description={t('uiLibrary.primitives.description')}
      />
      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <ButtonShowcase />
        <InputShowcase />
        <CheckboxShowcase />
        <SelectShowcase />
      </Grid>
    </section>
  );
}
